import isPropValid from '@emotion/is-prop-valid';
import { EnvironmentInfo } from '@storebrand-digital/insurance-environment-info';
import FlagProvider from '@unleash/proxy-client-react';
import { DittoProvider } from 'ditto-react';
import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DatadogProvider } from 'Components/Datadog/DatadogProvider';
import { unleashConfig } from 'Constants/unleash.constants';
import { AppRoutes } from 'Features/router';
import { StyleSheetManager } from 'styled-components';
import { ReactQueryTooling } from 'Utils/ReactQueryTooling';
import { showReactQueryToolingInTest } from 'Utils/showReactQueryToolingInTest';
import dittoData from '../../ditto/index';
import packagesJson from '../../package.json';
import { Authenticated } from './Authenticated';
import { GlobalStyle } from './global-style';

const queryClient = new QueryClient();

export const App = (): React.ReactElement => (
  <FlagProvider config={unleashConfig}>
    <DatadogProvider>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <DittoProvider source={dittoData} variant="base">
          <GlobalStyle />
          <EnvironmentInfo appName={packagesJson.name} />
          <QueryClientProvider client={queryClient}>
            {showReactQueryToolingInTest() && <ReactQueryTooling />}
            <Authenticated>
              <AppRoutes />
            </Authenticated>
          </QueryClientProvider>
        </DittoProvider>
      </StyleSheetManager>
    </DatadogProvider>
  </FlagProvider>
);

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: unknown): boolean {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}
